export default __webpack_public_path__ + "static/media/t4u-mobile_converted.26e35d2f.jpg";